const BASE_URL = process.env.REACT_APP_API_URL;

const API = {
  auth: {
    login: `${BASE_URL}/Auth/Login`,
    register: `${BASE_URL}/Auth/Register`,
    getUserByEmail: (email) => `${BASE_URL}/Auth/GetUserByEmail/${email}`,
    forgetPassword : `${BASE_URL}/Auth/forget-password/request`,
    confirmPassword : `${BASE_URL}/Auth/forget-password/confirm`
  },

  candidate: {
     register : `${BASE_URL}/Hiring/Candidate/register`,
     login : `${BASE_URL}/Hiring/Candidate/login`,
     get : `${BASE_URL}/Hiring/Candidate/get-by-id/{candidateId}`,
     getJobPostings : (candidateId) => `${BASE_URL}/Hiring/JobApplicant/get-by-candidate/${candidateId}`,
     create : `${BASE_URL}/Hiring/Candidate/set-password`,
     forgot : `${BASE_URL}/Hiring/Candidate/forget-password-request`,
     forgotConfirm : `${BASE_URL}/Hiring/Candidate/forget-password-confirm`
  },

  designation: {
    getAll: `${BASE_URL}/Designation/with-count/Lookup`,
    getRank: (level) => `${BASE_URL}/Designation/RankOptions/${level}`,
    create: `${BASE_URL}/Designation/Create`,
    lookupByLevels: `${BASE_URL}/Designation/Lookup/by-levels`,
    getAllByLevelsCount: (level) => `${BASE_URL}/Designation/with-count/Lookup?Level=${level}`

  },


    
  announcement: {
    add: `${BASE_URL}/Announcement/Create`,
    edit:  `${BASE_URL}/Announcement/Edit`,
    delete: (id) => `${BASE_URL}/Announcement/Delete/${id}`,
    getAll: `${BASE_URL}/Announcement/GetAll`,
  },

  domains : {
    getList : `${BASE_URL}/DomainKnowledges`,
  },

  reports: {
    // Point 13: optional periodType/referenceDate added (departmentId still works).
    getHiringReport: (departmentId, periodType = null, referenceDate = null) => {
      let url = `${BASE_URL}/Hiring/JobPosting/Get-Report`;
      const params = [];
      if (departmentId) params.push(`departmentId=${departmentId}`);
      if (periodType !== null && periodType !== undefined && periodType !== "")
        params.push(`periodType=${periodType}`);
      if (referenceDate) params.push(`referenceDate=${referenceDate}`);
      if (params.length) url += `?${params.join("&")}`;
      return url;
    },
    getJobApplicantReport: `${BASE_URL}/Hiring/JobApplicant/Get-Report`,
    getOfferLetterReport: (departmentId) =>
      departmentId
        ? `${BASE_URL}/Hiring/Contract/Get-Report?departmentId=${departmentId}`
        : `${BASE_URL}/Hiring/Contract/Get-Report`,
    // Point 13: month/year replaced by the shared periodType/referenceDate
    // contract. Response is now { period, data } - read the list from data.data.
    getExpenseReport: (departmentId, periodType = null, referenceDate = null) => {
      let url = `${BASE_URL}/ExpenseManagement/report/get-by-department`;
      const params = [];
      if (departmentId !== null && departmentId !== undefined && departmentId !== "")
        params.push(`DepartmentId=${departmentId}`);
      if (periodType !== null && periodType !== undefined && periodType !== "")
        params.push(`periodType=${periodType}`);
      if (referenceDate) params.push(`referenceDate=${referenceDate}`);
      if (params.length) url += `?${params.join("&")}`;
      return url;
    },
    getExpenseReportSupervisor: (periodType = null, referenceDate = null) => {
      let url = `${BASE_URL}/ExpenseManagement/report/get-by-supervisor`;
      const params = [];
      if (periodType !== null && periodType !== undefined && periodType !== "")
        params.push(`periodType=${periodType}`);
      if (referenceDate) params.push(`referenceDate=${referenceDate}`);
      if (params.length) url += `?${params.join("&")}`;
      return url;
    },
    getAttendanceReport: (departmentId = 1, month = null, year = null) => {
      let url = `${BASE_URL}/Attendance/Department-Attendance-By-MonthYear?DepartmentId=${departmentId}`;
      if (month !== null && month !== "") url += `&Month=${month}`;
      if (year !== null && year !== "") url += `&Year=${year}`;
      return url;
    },

    leaveRequestReport: (departmentId, month = null, year = null) => {
      let url = `${BASE_URL}/LeaveRequest/Get-By-Department?DepartmentId=${departmentId}`;
      if (month !== null && month !== "") {
        url += `&Month=${month}`;
      }
      if (year !== null && year !== "") {
        url += `&Year=${year}`;
      }
      return url;
    },

    getEmployeesBySkills: `${BASE_URL}/Employee/Get-By-SkillSet`,
    // Point 13: optional periodType/referenceDate (response is { period, data }).
    getDepartmentPerfomance: (departmentId, periodType = null, referenceDate = null) => {
      let url = `${BASE_URL}/PerformanceEvaluation/hr/departments/${departmentId}/reviews/analytics`;
      const params = [];
      if (periodType !== null && periodType !== undefined && periodType !== "")
        params.push(`periodType=${periodType}`);
      if (referenceDate) params.push(`referenceDate=${referenceDate}`);
      if (params.length) url += `?${params.join("&")}`;
      return url;
    },
  },

  skills: {
    getSkillsByEmployee: (employeeId) => `${BASE_URL}/Skills/Employee/${employeeId}`,
    getAvailableSkills: `${BASE_URL}/Skills/employee/Available-Skills`,
    addList: `${BASE_URL}/Skills/Employee/AddList`,
    getList: `${BASE_URL}/Skills/Get-List`,
    // Per Mudassir (May-24): JobPosting form now uses JobTitle-scoped skill
    // APIs. First returns the JobTitle's default/required skills (shown as
    // readonly chips). Second returns remaining department skills the
    // recruiter can add as extras (the JobTitle defaults are excluded so
    // duplicates are prevented at selection time). BE auto-merges defaults
    // + extras on JobPosting create/edit — request schema is unchanged.
    getJobTitleSkills: (jobTitleId) =>
      `${BASE_URL}/Skills/jobtitle/${jobTitleId}`,
    getAvailableSkillsForJobTitle: (jobTitleId) =>
      `${BASE_URL}/Skills/jobtitle/${jobTitleId}/available-skills`,
    createOrGet: `${BASE_URL}/Skills/create-or-get`,
  },

  // In your api/endpoints.js
  performanceReview: {
    getPerformanceReviews: (employeeId) =>
      `${BASE_URL}/PerformanceEvaluation/Employee/Performance-Reviews?employeeId=${employeeId}`,
    createPerformanceReview: `${BASE_URL}/PerformanceEvaluation/create`,
    getPreviousReview: (employeeId) =>
      `${BASE_URL}/PerformanceEvaluation/Get-Previous-Evaluation?employeeId=${employeeId}`,
    getLatestReviews: (departmentId) =>
      `/PerformanceEvaluation/hr/departments/${departmentId}/latest-reviews`,
  },

  permissionRoles: {
    set: `${BASE_URL}/PermissionRoles/manager`, //PUTs
    getByManager: (managerId) => `${BASE_URL}/PermissionRoles/manager/${managerId}`, //GET
  },
  userInvite: {
    acceptInvite: `${BASE_URL}/UserInvite/Accept-Invite`,
  },

  attendance: {
    addWorkingHrs: `${BASE_URL}/Attendance/Working-Hours/Create`, // updated
    getActiveWorkingHours: `${BASE_URL}/Attendance/Working-Hours/Get-Active`, // updated
    addCheckIn: `/Attendance/CheckIn`,
    addCheckOut: `${BASE_URL}/Attendance/CheckOut`,
    getAttendence: `${BASE_URL}/Attendance/User/GetTodayStatus`, // 403
    userAttendance: (employeeId, viewType, startDate, endDate) => {
      // Monthly view (viewType = 1)
      if (viewType === 1) {
        return `${BASE_URL}/Attendance/User-Attendance?employeeId=${employeeId}&viewType=${viewType}`;
      }

      if (startDate && endDate) {
        return `${BASE_URL}/Attendance/User-Attendance?employeeId=${employeeId}&viewType=${viewType}&startDate=${startDate}&endDate=${endDate}`;
      }

      // Fallback
      return `${BASE_URL}/Attendance/User-Attendance?employeeId=${employeeId}&viewType=${viewType}`;
    },

    getDepartmentAttendance: (departmentId, viewType = 0) =>
      `${BASE_URL}/Attendance/Department-Attendance?DepartmentId=${departmentId}&ViewType=${viewType}`,

    getDateDetail: (attendanceId) =>
      `${BASE_URL}/Attendance/Get-Detail?attendanceId=${attendanceId}`,

    // Supervisor/Manager team attendance (scoped to direct reports, per Mudassir handoff)
    supervisorToday: `${BASE_URL}/Attendance/Supervisor/Today`,
    supervisorTeamByMonthYear: (month, year) =>
      `${BASE_URL}/Attendance/Supervisor/Team-Attendance-By-MonthYear?month=${month}&year=${year}`,
    supervisorTeamAttendance: (viewType, startDate, endDate) =>
      `${BASE_URL}/Attendance/Supervisor/Team-Attendance?viewType=${viewType}${
        startDate ? `&startDate=${startDate}` : ""
      }${endDate ? `&endDate=${endDate}` : ""}`,
    supervisorEmployeeAttendance: (employeeId, viewType, startDate, endDate) =>
      `${BASE_URL}/Attendance/Supervisor/Employee-Attendance?employeeId=${employeeId}&viewType=${viewType}${
        startDate ? `&startDate=${startDate}` : ""
      }${endDate ? `&endDate=${endDate}` : ""}`,
    // Manager-facing AI attendance insights for a date range (direct reports,
    // per Mudassir Jun-15 handoff). Returns calculated numbers + AI explanation.
    supervisorTeamAttendanceInsights: (startDate, endDate) =>
      `${BASE_URL}/Attendance/Supervisor/Team-Attendance-Insights?startDate=${startDate}&endDate=${endDate}`,
    // Admin/HR company-wide AI attendance insights, scoped to ONE department
    // (departmentId required - keeps large company-wide data out of the AI service).
    adminAttendanceInsights: (departmentId, startDate, endDate) => {
      // "all" (All Departments) sends no departmentId so the backend runs the
      // company-wide insight; a real id or -1 (Executives) is sent as a filter.
      const dept =
        departmentId != null && departmentId !== "all" ? `departmentId=${departmentId}&` : "";
      return `${BASE_URL}/Attendance/Admin/Attendance-Insights?${dept}startDate=${startDate}&endDate=${endDate}`;
    },
    // Flight Risk / Retention insights (Jun-21 AI handoff).
    supervisorFlightRisk: (asOfDate = null) =>
      `${BASE_URL}/Attendance/Supervisor/Flight-Risk-Insights${
        asOfDate ? `?asOfDate=${asOfDate}` : ""
      }`,
    adminFlightRisk: (asOfDate = null, departmentId = null) => {
      let url = `${BASE_URL}/Attendance/Admin/Flight-Risk-Insights`;
      const params = [];
      if (asOfDate) params.push(`asOfDate=${asOfDate}`);
      if (departmentId) params.push(`departmentId=${departmentId}`);
      if (params.length) url += `?${params.join("&")}`;
      return url;
    },
  },

  // Point 13: routes renamed (Department-Report / Team-Report) and month/year
  // replaced by periodType/referenceDate. periodType is REQUIRED for WLB.
  // Response is now { period, data } - callers read the payload from data.
  workLifeBalance: {
    getDepartmentMonthlyReport: (departmentId, periodType, referenceDate) => {
      let url = `${BASE_URL}/Attendance/WorkLifeBalance/Department-Report?departmentId=${departmentId}&periodType=${periodType}`;
      if (referenceDate) url += `&referenceDate=${referenceDate}`;
      return url;
    },

    getEmployeeReport: (employeeId, periodType, referenceDate) => {
      let url = `${BASE_URL}/Attendance/WorkLifeBalance/Employee-Summary?employeeId=${employeeId}&periodType=${periodType}`;
      if (referenceDate) url += `&referenceDate=${referenceDate}`;
      return url;
    },

    // Supervisor/Manager team work-life balance (direct reports, per Mudassir handoff)
    getSupervisorTeamMonthlyReport: (periodType, referenceDate) => {
      let url = `${BASE_URL}/Attendance/WorkLifeBalance/Supervisor/Team-Report?periodType=${periodType}`;
      if (referenceDate) url += `&referenceDate=${referenceDate}`;
      return url;
    },
    getSupervisorEmployeeSummary: (employeeId, periodType, referenceDate) => {
      let url = `${BASE_URL}/Attendance/WorkLifeBalance/Supervisor/Employee-Summary?employeeId=${employeeId}&periodType=${periodType}`;
      if (referenceDate) url += `&referenceDate=${referenceDate}`;
      return url;
    },
  },

  benefitsDependents: {
    add: `${BASE_URL}/BenefitsDependents/AddDependents`,
  },

  complaint: {
    create: `${BASE_URL}/Complaint/Create`,
    getComplaint: (complaintId) => `${BASE_URL}/Complaint/Get-By-Id/${complaintId}`,
    getMyComplaint: `${BASE_URL}/Complaint/my-complaints`,
    getUserComplaints: (complainantUserId) =>
      `${BASE_URL}/Complaint/Get-User-Complaints/${complainantUserId}`, // newly added
    updateStatus: `${BASE_URL}/Complaint/UpdateComplaintStatus`, //newly added
    getAll: (departmentId = null) =>
      departmentId
        ? `${BASE_URL}/Complaint/Get-All?departmentId=${departmentId}`
        : `${BASE_URL}/Complaint/Get-All`,
  },

  complaintType: {
    getAll: `${BASE_URL}/ComplaintType/Get-All`,
    listWithSubTypes: `${BASE_URL}/ComplaintType/List-With-Subtypes`,
    getSubTypes: (complaintTypeId) => `${BASE_URL}/ComplaintType/Get-SubTypes/${complaintTypeId}`,
  },

  user: {
    getById: (userId) => `${BASE_URL}/User/get-by-Id/${userId}`,
    getList: (departmentId) =>
      departmentId
        ? `${BASE_URL}/User/Get-List?departmentId=${departmentId}`
        : `${BASE_URL}/User/Get-List`,
  },

  userInvites: {
    userInvite : `${BASE_URL}/UserInvite/create-employee-invite`,
    financeInvite : `${BASE_URL}/UserInvite/create-finance-invite`,
    getInvites : `${BASE_URL}/UserInvite/my-invites`
  },

  compliance: {
    create: `${BASE_URL}/Compliance/Create`,
    addVersion: `${BASE_URL}/Compliance/AddVersion`,
    replaceFile: `${BASE_URL}/Compliance/ReplaceFile`,

    getById: (complianceId) => `${BASE_URL}/Compliance/Get-By-Id/${complianceId}`,
    getWithVersions: (complianceId) => `${BASE_URL}/Compliance/Get-With-Versions/${complianceId}`,
    getAll: `${BASE_URL}/Compliance/Get-All`,

    // Employee-side actions
    getPendingByEmployee: `${BASE_URL}/Compliance/employee/pending`,
    getAcknowledgedByEmployee: (userId) => `${BASE_URL}/Compliance/employee/${userId}/acknowledged`,
    acknowledge: `${BASE_URL}/Compliance/employee/acknowledge`,
    getAllByEmployee: `${BASE_URL}/Compliance/employee/Get-All`,

    // File download
    download: (versionId) => `${BASE_URL}/Compliance/download?versionId=${versionId}`,
  },

  correctiveAction: {
    create: `${BASE_URL}/Complaint/CorrectiveAction/Create`,
    getListByComplaint: (complaintId) =>
      `${BASE_URL}/Complaint/CorrectiveAction/Get-By-Complaint/${complaintId}`,
    getById: (correctiveActionId) =>
      `${BASE_URL}/Complaint/CorrectiveAction/Get-By-Id/${correctiveActionId}`,
    getAll: `${BASE_URL}/Complaint/CorrectiveAction/Get-All`,
  },

  employeeEmergencyContact: {
    getEmergencyDetail: (employeeId) =>
      `${BASE_URL}/EmployeeEmergencyContact/Get-Employee-Contacts/${employeeId}`,
    addEmergencyContact: `${BASE_URL}/EmployeeEmergencyContact/Create`,
  },

  expenseManagement: {
    getEmployeeExpenses: `${BASE_URL}/ExpenseManagement/employee/list`,
    createExpenseManagementByEmp: `${BASE_URL}/ExpenseManagement/Create`,
    downloadReceipt: (expenseManagementId) =>
      `${BASE_URL}/ExpenseManagement/Download/Receipt/${expenseManagementId}`,
    downloadSheet: (expenseManagementId) =>
      `${BASE_URL}/ExpenseManagement/Download/ExpenseSheet/${expenseManagementId}`,
    getExpenseListBySupervisor: `${BASE_URL}/ExpenseManagement/supervisor/List`,
    updateStatus: `${BASE_URL}/ExpenseManagement/Update-Status`,

    delete: (expenseManagementId) =>
      `${BASE_URL}/ExpenseManagement/Expense-Termination/${expenseManagementId}`,
    //New URLs added in endpoint.js
    getList: `${BASE_URL}/ExpenseManagement/Get-List`,

    // Finance workflow (Points 7 & 8). Finance owns approve/reject/mark-paid.
    financeList: `${BASE_URL}/ExpenseManagement/finance/list`,
    financeUpdateStatus: `${BASE_URL}/ExpenseManagement/finance/update-status`,
    financePaymentsReport: (periodType = null, referenceDate = null, departmentId = null) => {
      let url = `${BASE_URL}/ExpenseManagement/finance/report/payments`;
      const params = [];
      if (periodType !== null && periodType !== undefined && periodType !== "")
        params.push(`periodType=${periodType}`);
      if (referenceDate) params.push(`referenceDate=${referenceDate}`);
      if (departmentId) params.push(`departmentId=${departmentId}`);
      if (params.length) url += `?${params.join("&")}`;
      return url;
    },
    // Employee proof-of-payment report (only Paid expenses for the signed-in user).
    employeePaymentReport: (periodType = null, referenceDate = null) => {
      let url = `${BASE_URL}/ExpenseManagement/employee/payment-report`;
      const params = [];
      if (periodType !== null && periodType !== undefined && periodType !== "")
        params.push(`periodType=${periodType}`);
      if (referenceDate) params.push(`referenceDate=${referenceDate}`);
      if (params.length) url += `?${params.join("&")}`;
      return url;
    },
  },

  hardwareAssets: {
    add: `${BASE_URL}/HardwareAssets/Add`,
    getById: (hardwareAssetId) => `${BASE_URL}/HardwareAssets/Get-By-Id/${hardwareAssetId}`,
    getEmployeeAssets: (employeeId) =>
      `${BASE_URL}/HardwareAssets/Get-Employee-Assets/${employeeId}`,
    getAll: `${BASE_URL}/HardwareAssets/Get-All`,
    update: `${BASE_URL}/HardwareAssets/Update`,
    delete: (id) => `${BASE_URL}/HardwareAssets/Delete/${id}`,
  },

  softwareAssets: {
    add: `${BASE_URL}/SoftwareAssets/Add`,
    getById: (softwareAssetId) => `${BASE_URL}/SoftwareAssets/Get-By-Id/${softwareAssetId}`,
    getEmployeeAssets: (employeeId) =>
      `${BASE_URL}/SoftwareAssets/Get-Employee-Assets/${employeeId}`,
    getAll: `${BASE_URL}/SoftwareAssets/Get-All`,
    update: `${BASE_URL}/SoftwareAssets/Update`,
    delete: (id) => `${BASE_URL}/SoftwareAssets/Delete/${id}`,
  },

  //  Hiring Process APIs
  hiringJobPosting: {
    getAllPostings: `${BASE_URL}/Hiring/JobPosting/Get-All-Postings`,
    getAll: `${BASE_URL}/Hiring/JobPosting/Get-List`,
    add: `${BASE_URL}/Hiring/JobPosting/Create`,
    update: `${BASE_URL}/Hiring/JobPosting/Edit`,
    delete: (id) => `${BASE_URL}/Hiring/JobPosting/Post-Termination/${id}`,
    getPostingById: (id) => `${BASE_URL}/Hiring/JobPosting/GetpostingById/${id}`,
    // Per Mudassir (May-20): marks a posting as Filled. Backend blocks
    // further hiring-pipeline actions once Filled; onboarding remains open.
    markAsFilled: (jobPostingId) =>
      `${BASE_URL}/Hiring/JobPosting/mark-as-filled/${jobPostingId}`,
    explore: (candidateId) =>
  candidateId
    ? `${BASE_URL}/Hiring/JobPosting/candidate/explore?candidateId=${candidateId}`
    : `${BASE_URL}/Hiring/JobPosting/candidate/explore`,

    // Internal applicant (logged-in employee) — AI-powered openings
    employeeExplore: `${BASE_URL}/Hiring/JobPosting/employee/explore`,
  },

  holiday: {
    getList: `${BASE_URL}/Holiday/Get-List`,
  },

  hiringJobApplicant: {
    apply: `${BASE_URL}/Hiring/JobApplicant/Apply`,
    getAllWithJobPosting: `${BASE_URL}/Hiring/JobApplicant/GetAll-With-JobPosting`,
    getListByPosting: (jobPostingId) =>
      `${BASE_URL}/Hiring/JobApplicant/Get-By-JobPosting/${jobPostingId}`,
    getById: (jobApplicantId) => `${BASE_URL}/Hiring/JobApplicant/Get-By-Id/${jobApplicantId}`,
    addJobApplicantAction: `/Hiring/JobApplicant/JobApplicantAction`,
    getEmailStatus: (jobApplicantId) =>
      `${BASE_URL}/Hiring/JobApplicant/GetEmailStatus?jobApplicantId=${jobApplicantId}`,
    sendEmail: `${BASE_URL}/Hiring/JobApplicant/SendEmail`,
    login: `${BASE_URL}/Hiring/JobApplicant/Login`,
    delete: (jobApplicantId) => `${BASE_URL}/Hiring/JobApplicant/Delete/${jobApplicantId}`,
    reject: (jobApplicantId) => `${BASE_URL}/Hiring/JobApplicant/Reject/${jobApplicantId}`,

    // Internal applicant (logged-in employee)
    myApplications: `${BASE_URL}/Hiring/JobApplicant/employee/my-applications`,
    // Per Swagger (confirmed by Mudassir 2026-05-20): path is /internal/apply,
    // body is multipart with jobPostingId (req), resumeFile (req), coverLetterFile (opt).
    internalApply: `${BASE_URL}/Hiring/JobApplicant/internal/apply`,
  },

  applicantTalentProfile: {
    getById: (id) => `${BASE_URL}/Hiring/ApplicantTalentProfile/${id}`,
    getByApplication: (jobApplicationId) =>
      `${BASE_URL}/Hiring/ApplicantTalentProfile/by-application/${jobApplicationId}`,
    getDetailById: (id) => `${BASE_URL}/Hiring/ApplicantTalentProfile/detail/${id}`,
    getDetailByApplication: (jobApplicationId) =>
      `${BASE_URL}/Hiring/ApplicantTalentProfile/detail/by-application/${jobApplicationId}`,
  },

  aiEvaluation: {
  getByApplication: (jobApplicationId) =>
    `${BASE_URL}/Hiring/ApplicantTalentProfile/ai-evaluation/by-application/${jobApplicationId}`,
},

  hiringInterviews: {
    proposeInterview: `${BASE_URL}/Hiring/Interview/ProposeInterviewSlots`,
    getByJobApplicantId: (jobApplicantId) =>
      `${BASE_URL}/Hiring/Interview/Get-By-JobApplicantId/${jobApplicantId}`,
    selectSchedule: `${BASE_URL}/Hiring/Interview/Applicant/Select-Schedule`,
    getEmployeeSelectedDate: (jobApplicantId) =>
      `${BASE_URL}/Hiring/Interview/Applicant/Get-Selected-Date/${jobApplicantId}`,


    getRoundsByApplication: (jobApplicationId) =>
      `${BASE_URL}/Hiring/Interview/hr/rounds/by-application/${jobApplicationId}`,
    getRoundById: (roundId) => `${BASE_URL}/Hiring/Interview/round/${roundId}`,
    proposeSlots: `${BASE_URL}/Hiring/Interview/round/propose-slots`,
    completeRound: `${BASE_URL}/Hiring/Interview/hr/round/complete`,

    // Applicant-side (career portal view)
    getApplicantRoundsByApplication: (jobApplicationId) =>
      `${BASE_URL}/Hiring/Interview/applicant/rounds/by-application/${jobApplicationId}`,
    selectSlot: `${BASE_URL}/Hiring/Interview/applicant/Select-Slot`,
  },

    feedback: {
    getById:(feedbackId) => `${BASE_URL}/Hiring/Feedback/get-by-id/${feedbackId}`,

    getByJobApplicantId: (jobApplicantId) =>
      `${BASE_URL}/Hiring/Feedback/get-by-applicant?applicantId=${jobApplicantId}`,
   
    provideFeedback: `${BASE_URL}/Hiring/Feedback/Provide-feedback`,
  },

  hiringContracts: {
    sendContracts: `${BASE_URL}/Hiring/Contract/HR/Send-Contract`,
    contractAcceptance: `${BASE_URL}/Hiring/Contract/JobApplicant/Contract-Acceptance`,
    getContractByApplicant: (jobApplicantId) =>
      `${BASE_URL}/Hiring/Contract/Get-By-Applicant/${jobApplicantId}`,
    getReceiveContractByApplicant: (jobApplicantId) =>
      `${BASE_URL}/Hiring/Contract/Received/Get-By-applicant/${jobApplicantId}`,
    getAllReceiveContracts: `${BASE_URL}/Hiring/Contract/Received/Get-All`,
    getByUserId: (employeeId) => `${BASE_URL}/Hiring/Contract/Received/Get-By-Employee/${employeeId}`,
    getByEmployeeId: (employeeId) =>
      `${BASE_URL}/Hiring/Contract/Received/Get-By-Employee/${employeeId}`,
  },

  hiringOnboardings: {
    addOnboarding: `${BASE_URL}/Hiring/Onboarding`,
    updateOnboarding: `${BASE_URL}/Hiring/Onboarding`,
    getByApplicant: (jobApplicantId) =>
      `${BASE_URL}/Hiring/Onboarding/Get-By-Applicant/${jobApplicantId}`,

  },

  // Dynamic hiring document package flow (per Mudassir Jun-16 handoff).
  // Replaces the old fixed Contract endpoints.
  hiringDocumentPackage: {
    hrStart: (jobApplicantId) =>
      `${BASE_URL}/Hiring/HiringDocumentPackage/HR/Start/${jobApplicantId}`,
    getByApplicant: (jobApplicantId) =>
      `${BASE_URL}/Hiring/HiringDocumentPackage/Get-By-Applicant/${jobApplicantId}`,
    hrSubmitTemplates: `${BASE_URL}/Hiring/HiringDocumentPackage/HR/Submit-Templates`,
    applicantSubmit: `${BASE_URL}/Hiring/HiringDocumentPackage/Applicant/Submit`,
    hrVerify: `${BASE_URL}/Hiring/HiringDocumentPackage/HR/Verify`,
    hrWaive: (hiringDocumentItemId) =>
      `${BASE_URL}/Hiring/HiringDocumentPackage/HR/Waive/${hiringDocumentItemId}`,
    // File download (per Jun-17 doc): fetch a specific file version through the
    // backend instead of opening stored static paths. role = HrTemplate |
    // ApplicantSubmitted | HrFinal.
    fileDownload: (hiringDocumentItemId, role) =>
      `${BASE_URL}/Hiring/HiringDocumentPackage/File/${hiringDocumentItemId}/${role}`,
  },

  // Hiring document template repository (per Mudassir Jul-15 handoff). HR/Admin
  // manages the reusable templates on the Company Documents page: list the nine
  // slots, upload/replace (PUT multipart { documentType, file }; backend
  // auto-versions 1.0, 2.0, ...), download the current file, list version
  // history, and download any past version. BASE_URL already includes /api, so
  // do NOT reuse the relative downloadUrl from the response.
  hiringDocumentTemplate: {
    getList: `${BASE_URL}/Hiring/HiringDocumentTemplate`,
    upload: `${BASE_URL}/Hiring/HiringDocumentTemplate`,
    downloadCurrent: (documentType) =>
      `${BASE_URL}/Hiring/HiringDocumentTemplate/File/${documentType}`,
    history: (documentType) =>
      `${BASE_URL}/Hiring/HiringDocumentTemplate/${documentType}/History`,
    downloadVersion: (hiringDocumentTemplateId) =>
      `${BASE_URL}/Hiring/HiringDocumentTemplate/File/Version/${hiringDocumentTemplateId}`,
  },

  // Employee Document Folder (per Mudassir Jun-17 handoff). Master document
  // view for an employee; completed hiring packages are linked here after
  // applicant-to-employee conversion.
  employeeDocumentFolder: {
    getEmployees: `${BASE_URL}/EmployeeDocumentFolder/employees`,
    getByEmployee: (employeeId) =>
      `${BASE_URL}/EmployeeDocumentFolder/employee/${employeeId}`,
    // Logged-in employee's own document folder (per backend Jun handoff).
    // Resolves to the current user from the auth token; no employeeId needed.
    getMine: `${BASE_URL}/EmployeeDocumentFolder/me`,
  },

  leavePolicy: {
    addLeavePolicy: `${BASE_URL}/LeavePolicy/Create`, // no diff
    // getList: `${BASE_URL}/LeavePolicy/List`,    not used
    getCurrentYearList: `${BASE_URL}/LeavePolicy/Current-Year`, // 403
    myBalance: `${BASE_URL}/LeavePolicy/My-Balances`, // no diff
  },
  leaveRequest: {
    createLeaveRequest: `${BASE_URL}/LeaveRequest/Create`, // no diff
    getAll: `${BASE_URL}/LeaveRequest/Get-All`, // check pending
    createHRReview: `${BASE_URL}/LeaveRequest/HR/Review`, // no diff
    myRequests: `${BASE_URL}/LeaveRequest/My-Requests`, // no diff
    getPendingRequests: (departmentId = "") =>
      `${BASE_URL}/LeaveRequest/Pending-Approvals${departmentId ? `/${departmentId}` : ""}`, // updated
    // Supervisor/Manager leave approval flow (per Mudassir handoff doc)
    supervisorPendingApprovals: `${BASE_URL}/LeaveRequest/Supervisor/Pending-Approvals`,
    supervisorTeamAvailability: (leaveRequestId) =>
      `${BASE_URL}/LeaveRequest/Supervisor/Team-Availability/${leaveRequestId}`,
    supervisorReview: `${BASE_URL}/LeaveRequest/Supervisor/Review`,
    supervisorTeamRequests: (queryString = "") =>
      `${BASE_URL}/LeaveRequest/Supervisor/Team-Requests${queryString ? `?${queryString}` : ""}`,
    // HR/Admin corrective action: force-cancel a leave request (approval now
    // belongs to the supervisor; HR keeps only this admin-correction action).
    adminCancel: (leaveRequestId) => `${BASE_URL}/LeaveRequest/Admin-Cancel/${leaveRequestId}`,
  },

  careerPaths : {
     getListByLookup : (departmentId) => `${BASE_URL}/CareerPath/lookup?DepartmentId=${departmentId}`,
     create : `${BASE_URL}/CareerPath/create`,
     createTransitions : `${BASE_URL}/CareerPath/transitions`,
     update: `${BASE_URL}/CareerPath/update`,
     getCareerPath : (id) => `${BASE_URL}/CareerPath/${id}`,
     getByEmployee : (employeeId) => `${BASE_URL}/CareerPath/${employeeId}/career-path`,
     getAlternativePaths : (employeeId)=> `${BASE_URL}/CareerPath/${employeeId}/career-path/alternatives`,
     // Employee-authorized endpoints (per Mudassir 2026-05-20). Use these for
     // the Employee Dashboard CareerPath pages. Same response shape as the
     // HR-side endpoints, wrapped in { isApplicable, message, data }.
     getMyCareerPath: `${BASE_URL}/CareerPath/me/career-path`,
     getMyAlternativePaths: `${BASE_URL}/CareerPath/me/career-path/alternatives`,
     getSupervisors : (employeeId, jobTitleId, isInternal = false) => {
       // isInternal flag is only relevant for the internal-applicant flow.
       // We only append it when explicitly true so the existing alternative-
       // paths flow keeps its current URL shape untouched.
       const base = `${BASE_URL}/Employee/career-paths/supervisors?employeeId=${employeeId}&jobTitleId=${jobTitleId}`;
       return isInternal ? `${base}&isInternal=true` : base;
     },
     // Career transition analytics for an internal applicant (per Mudassir 2026-05-20)
     getApplicantTransitionAnalytics: (jobApplicantId) =>
       `${BASE_URL}/CareerPath/job-applicants/${jobApplicantId}/career-transition-analytics`,
     // Internal-applicant career transition submission (per Mudassir 2026-05-20).
     // Distinct from createTransitions above — validations differ from the
     // standard alternative-paths flow.
     submitInternalTransition: `${BASE_URL}/CareerPath/internal-applications/transitions`,
  },

  jobTitle: {
    getList: (departmentId) => `${BASE_URL}/JobTitle/list?DepartmentId=${departmentId}`,
    getById: (id) => `${BASE_URL}/JobTitle/${id}`,
    create: `${BASE_URL}/JobTitle/create`,
    update: `${BASE_URL}/JobTitle/update`,
    getListByLookup: (departmentId) => `${BASE_URL}/JobTitle/lookup?departmentId=${departmentId}`,
  },

  employee: {
    create: `${BASE_URL}/Employee/Create`,
    createInvite: `${BASE_URL}/Employee/invited/create`, 
    checkWorkEmailExists: (workEmail) => `${BASE_URL}/Employee/CheckWorkEmailExists/${workEmail}`,
    supervisors: (designationId, departmentId) =>
      `${BASE_URL}/Employee/supervisors?designationId=${designationId}&departmentId=${departmentId}`,
    directReports: (supervisorId) =>
      `${BASE_URL}/Employee/direct-reports?supervisorId=${supervisorId}`,
    getAll: (departmentId, hasDocuments) => {
  let url = `${BASE_URL}/Employee/Get-All-Employees`;
  const params = [];

  if (hasDocuments !== undefined && hasDocuments !== null) {
    params.push(`hasDocuments=${hasDocuments}`);
  }

  if (departmentId) {
    params.push(`departmentId=${departmentId}`);
  }

  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }

  return url;
},
    getMyEmployees: `${BASE_URL}/Employee/supervisor/direct-reports`,
    employeeGetById: (employeeId) => `${BASE_URL}/Employee/Get-by-Id/${employeeId}`,
    getMyDetail: `${BASE_URL}/Employee/my-detail`,
    getCompensations: (employeeId) => `${BASE_URL}/Compensations/employee/${employeeId}`,
    getMyCompensations: `${BASE_URL}/Compensations/me`,
    getEmployment: (employeeId) => `${BASE_URL}/Employment/employee/${employeeId}`,
    getHierDirectReports: (supervisorId) =>
      `${BASE_URL}/Employee/org-hierarchy/direct-reports?supervisorId=${supervisorId}`,
    getUserHierarchy: `${BASE_URL}/Employee/org-hierarchy`,
    getAllOverview: (departmentId) =>
      departmentId
        ? `${BASE_URL}/Employee/Get-All-Overview?departmentId=${departmentId}`
        : `${BASE_URL}/Employee/Get-All-Overview`,

    // getLastEmployeeNumber: ${BASE_URL}/Employee/GetLastEmployeeNumber,
    getPersonalIds: `${BASE_URL}/Employee/Get-Ids`,
    checkEmployeeExists: (empId) => `${BASE_URL}/Employee/Check-Exist/${empId}`,
    getPersonalInfoByPostingTitle: (jobTitle) =>
      `${BASE_URL}/Employee/Get-PersonalInfo-By-PostingTitle/${jobTitle}`,
    getAllEmployeeNumbers: ` ${BASE_URL}/Employee/Get-All-EmployeeNumbers`,
    GetWithJobById: (employeeId) => `${BASE_URL}/Employee/Get-With-Job/${employeeId}`,
    updatePersonalInfo: (personalId) => `${BASE_URL}/Employee/UpdatePersonalInfo/${personalId}`, //Unknw APi in beckend
  },

  department: {
    getList: `${BASE_URL}/Department/list`,
    getListByLookup: `${BASE_URL}/Department/lookup`,
    update: `${BASE_URL}/Department/update`,
    getByEmployeeId: (employeeId) => `${BASE_URL}/Employee/Get-By-EmployeeId/${employeeId}`,
    getById: (id) => `${BASE_URL}/Department/${id}`,
    myDepartment: `${BASE_URL}/Department/My-Department`,
    createDepartment: `${BASE_URL}/Department/create`,
    // getListByManagerFlag: `${BASE_URL}/Department/GetList-with-manager-flag`,
  },

  // Payroll / paycheck creation + history (Points 14 & 15, Mudassir Jun-19).
  // BASE_URL already includes /api, so these map to /api/Payroll etc.
  payroll: {
    create: `${BASE_URL}/Payroll`,
    getByEmployee: (employeeId) => `${BASE_URL}/Payroll/employee/${employeeId}`,
    me: `${BASE_URL}/Payroll/me`,
  },

  // Bonus / additional compensation (Point 17).
  bonus: {
    recommend: `${BASE_URL}/Bonus/recommend`,
    create: `${BASE_URL}/Bonus`,
    review: (bonusId) => `${BASE_URL}/Bonus/${bonusId}/review`,
    pending: `${BASE_URL}/Bonus/pending`,
    // HR-wide bonuses (Mudassir Jun-21). Optional ?status=Recommended|Approved|Rejected|Paid.
    all: (status) => `${BASE_URL}/Bonus/all${status ? `?status=${status}` : ""}`,
    getByEmployee: (employeeId) => `${BASE_URL}/Bonus/employee/${employeeId}`,
    me: `${BASE_URL}/Bonus/me`,
  },

  // W-2 year-end income/tax summary (Point 18). Derived from saved paychecks.
  w2: {
    getByEmployee: (employeeId, year) => `${BASE_URL}/W2/employee/${employeeId}/${year}`,
    me: (year) => `${BASE_URL}/W2/me/${year}`,
  },

  // Finance actor profile (Points 7 & 8). Separate from the employee profile.
  finance: {
    getProfile: `${BASE_URL}/finance/profile`,
    updateProfile: `${BASE_URL}/finance/profile`,
  },
};

export default API;
